module.exports = __webpack_public_path__ + "img/flowers-768x1024.a079913d.jpeg";